import { SettingsParser } from "../../../settings-parser";
import { FixedDimension, ObjectCreator } from "../../../../../../../../web-graphics";
import { SimpleVisualizatorSettings } from "../../../../settings/simple-visualizator-settings";

export class PlotControlsContentParser extends SettingsParser {
  constructor() {
    super();
  }

  static createSettings(settings, defaultSettings) {
    if (settings === undefined) {
      if (defaultSettings !== undefined) {
        return ObjectCreator.deepCopy(defaultSettings);
      }
      return undefined;
    }
    let parsedSettings = ObjectCreator.merge(settings, defaultSettings);
    let topHeight = (parsedSettings.height ?? 0) + (parsedSettings.margin?.top ?? 0) + (parsedSettings.margin?.bottom ?? 0);
    let contentBordersSettings = settings._plotSettings.contentBorders;
    if (contentBordersSettings !== undefined && topHeight > 0) {
      contentBordersSettings.topHeight = new FixedDimension(topHeight);
    }
    return parsedSettings;
  }

  parse(settings, defaultSettings) {
    let parsedSettings = PlotControlsContentParser.createSettings(settings, defaultSettings);
    if (parsedSettings === undefined) {
      return undefined;
    }
    return new SimpleVisualizatorSettings(parsedSettings);
  }
}
